// Module
var code = "<div id=\"content\">\n    <h2>오류</h2>\n    <p>{{ reason }}</p>\n</div>";
// Exports
module.exports = code;